module.exports = __webpack_public_path__ + "assets/da566f7ef026db07a55f6c5e7354e379.png";